import { useRouter } from "next/router";
import { FunctionComponent } from "react";

import { Box } from "@mui/system";

import { LinkButton } from "./button";

interface LanguageSwitchProps {
  variant: "code1" | "navigation1";
}

export const LanguageSwitch: FunctionComponent<LanguageSwitchProps> = ({
  variant,
}) => {
  const { asPath } = useRouter();

  return (
    <Box sx={{ display: "flex", gap: "36px" }}>
      <LinkButton text={"ENG"} variant={variant} url={asPath} locale={"en"} />

      <LinkButton text={"PL"} variant={variant} url={asPath} locale={"pl"} />
    </Box>
  );
};
